import { ProjectPhase } from 'api/project';
import { Template, TemplatesHttpClient } from '../../api';
import { ProjectTemplateApi } from '../types';

const NAMESPACE = '/templates/projects';

export type ProjectPhaseOption = Pick<
  ProjectPhase,
  'projectPhaseId' | 'projectPhaseName'
> &
  Pick<Template, 'templateId' | 'templateName'>;

class ProjectTemplateHTTPClient extends TemplatesHttpClient {
  public getAllTemplates(): Promise<ProjectTemplateApi[]> {
    return this.get<ProjectTemplateApi[]>(NAMESPACE);
  }

  public getPhases(): Promise<ProjectPhaseOption[]> {
    return this.get<ProjectPhaseOption[]>(`${NAMESPACE}/get-phases`);
  }
}

export const ProjectTemplatesAPI = new ProjectTemplateHTTPClient();
